// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* \\3c !-- HTML !-->
<button class="button-33" role="button">Button 33</button> */

/* CSS */
.button-33 {
  background-color: #c2fbd7;
  border-radius: 100px;
  box-shadow: rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px,
    rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px,
    rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px;
  color: green;
  cursor: pointer;
  display: inline-block;
  font-family: "Outfit", "Inter", sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 10px;
  font-weight: 600;
}

.button-33:hover {
  box-shadow: rgba(44, 187, 99, 0.35) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.25) 0 1px 2px,
    rgba(44, 187, 99, 0.25) 0 2px 4px, rgba(44, 187, 99, 0.25) 0 4px 8px,
    rgba(44, 187, 99, 0.25) 0 8px 16px, rgba(44, 187, 99, 0.25) 0 16px 32px;
  transform: scale(1.05) rotate(-1deg);
}

.button-33-red {
  /* background-color: #f9b2b2; */
  border-radius: 100px;
  color: red;
  cursor: pointer;
  display: inline-block;
  font-family: "Outfit", "Inter", sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  box-shadow: rgba(218, 32, 60, 0.35) 0 -25px 18px -14px inset, rgba(187, 44, 44, 0.023) 0 1px 2px,
  rgba(187, 44, 46, 0.25) 0 2px 4px, rgba(187, 44, 44, 0.25) 0 4px 8px,
  rgba(232, 26, 60, 0.25) 0 8px 16px, rgba(210, 16, 42, 0.25) 0 16px 32px;
}

.button-33-red:hover {
  transform: scale(1.05) rotate(-1deg);
  box-shadow: rgba(218, 32, 60, 0.35) 0 -25px 18px -14px inset, rgba(187, 44, 44, 0.023) 0 1px 2px,
  rgba(135, 4, 6, 0.25) 0 2px 4px, rgba(232, 87, 87, 0.25) 0 4px 8px,
  rgba(232, 26, 60, 0.25) 0 8px 16px, rgba(210, 16, 42, 0.25) 0 16px 32px;
}

.applied-text-red {
  color: #2954a5 !important;
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.coupon-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e5e5;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  border-radius: 1rem;
  overflow: hidden;
  background-color: white;
}

.dark .coupon-card {
  background-color: var(--dark-blue);
}

.coupon-card-body {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.7rem;
}

.coupon-card-title {
  font-size: 1rem !important;
  font-weight: 600 !important;
  line-height: normal !important;
}

.coupon-card-description {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: var(--blue);
}

.dark .coupon-card-description {
  color: var(--light-blue);
}

.coupon-image-box {
  width: 3rem;
  height: 3rem;
  /* border-radius: 50%;
    background-color: #f5f5f5; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.coupon-card-image {
  object-fit: contain;
  height: 100%;
  width: 100%;
}

.coupon-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view-details-text {
  display: flex;
  align-items: center;
  font-size: 12px !important;
  color: #747474;
  line-height: unset !important;
}

.coupon-card-code {
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  padding: 0.2rem 0.5rem;
  font-size: 12px;
}

.coupon-card-code-text {
  letter-spacing: 1px !important;
  line-height: unset !important;
}

.coupon-card-btn {
  border-top: 1px solid #e5e5e5;
  text-transform: capitalize;
  letter-spacing: 3px;
  overflow: hidden;
}

.coupon-card-btn > div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem;
  width: 100%;
}

.apply-btn {
  background-color: #6da0ff0d;
  color: var(--blue);
}

.dark .apply-btn {
  background-color: #00123552;
  color: var(--light-blue);
}

.applied-btn {
  background-color: #eaffe9;
  color: #00c400;
}

.dark .applied-btn {
  background-color: #033f0087;
  color: #00c400;
}

.coupon-btn-text {
  letter-spacing: 3px !important;
  overflow: hidden;
  font-size: 14px !important;
  font-weight: bold !important;
}

.coupon-card-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.7rem;
  border-top: 1px dashed #999;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/couponsCard/index.css"],"names":[],"mappings":"AAAA;4DAC4D;;AAE5D,QAAQ;AACR;EACE,yBAAyB;EACzB,oBAAoB;EACpB;;2EAEyE;EACzE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;2EAEyE;EACzE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB;;yEAEuE;AACzE;;AAEA;EACE,oCAAoC;EACpC;;yEAEuE;AACzE;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kFAAkF;EAClF,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;gCAC8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":["/* <!-- HTML !-->\n<button class=\"button-33\" role=\"button\">Button 33</button> */\n\n/* CSS */\n.button-33 {\n  background-color: #c2fbd7;\n  border-radius: 100px;\n  box-shadow: rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px,\n    rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px,\n    rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px;\n  color: green;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  padding: 7px 20px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 250ms;\n  border: 0;\n  font-size: 16px;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  margin-right: 10px;\n  font-weight: 600;\n}\n\n.button-33:hover {\n  box-shadow: rgba(44, 187, 99, 0.35) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.25) 0 1px 2px,\n    rgba(44, 187, 99, 0.25) 0 2px 4px, rgba(44, 187, 99, 0.25) 0 4px 8px,\n    rgba(44, 187, 99, 0.25) 0 8px 16px, rgba(44, 187, 99, 0.25) 0 16px 32px;\n  transform: scale(1.05) rotate(-1deg);\n}\n\n.button-33-red {\n  /* background-color: #f9b2b2; */\n  border-radius: 100px;\n  color: red;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  padding: 7px 20px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 250ms;\n  border: 0;\n  font-size: 16px;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  margin-right: 10px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  box-shadow: rgba(218, 32, 60, 0.35) 0 -25px 18px -14px inset, rgba(187, 44, 44, 0.023) 0 1px 2px,\n  rgba(187, 44, 46, 0.25) 0 2px 4px, rgba(187, 44, 44, 0.25) 0 4px 8px,\n  rgba(232, 26, 60, 0.25) 0 8px 16px, rgba(210, 16, 42, 0.25) 0 16px 32px;\n}\n\n.button-33-red:hover {\n  transform: scale(1.05) rotate(-1deg);\n  box-shadow: rgba(218, 32, 60, 0.35) 0 -25px 18px -14px inset, rgba(187, 44, 44, 0.023) 0 1px 2px,\n  rgba(135, 4, 6, 0.25) 0 2px 4px, rgba(232, 87, 87, 0.25) 0 4px 8px,\n  rgba(232, 26, 60, 0.25) 0 8px 16px, rgba(210, 16, 42, 0.25) 0 16px 32px;\n}\n\n.applied-text-red {\n  color: #2954a5 !important;\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n}\n.coupon-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e5e5e5;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n  border-radius: 1rem;\n  overflow: hidden;\n  background-color: white;\n}\n\n.dark .coupon-card {\n  background-color: var(--dark-blue);\n}\n\n.coupon-card-body {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding: 0.7rem;\n}\n\n.coupon-card-title {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n}\n\n.coupon-card-description {\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: var(--blue);\n}\n\n.dark .coupon-card-description {\n  color: var(--light-blue);\n}\n\n.coupon-image-box {\n  width: 3rem;\n  height: 3rem;\n  /* border-radius: 50%;\n    background-color: #f5f5f5; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.coupon-card-image {\n  object-fit: contain;\n  height: 100%;\n  width: 100%;\n}\n\n.coupon-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.view-details-text {\n  display: flex;\n  align-items: center;\n  font-size: 12px !important;\n  color: #747474;\n  line-height: unset !important;\n}\n\n.coupon-card-code {\n  border: 1px solid #d7d7d7;\n  border-radius: 8px;\n  padding: 0.2rem 0.5rem;\n  font-size: 12px;\n}\n\n.coupon-card-code-text {\n  letter-spacing: 1px !important;\n  line-height: unset !important;\n}\n\n.coupon-card-btn {\n  border-top: 1px solid #e5e5e5;\n  text-transform: capitalize;\n  letter-spacing: 3px;\n  overflow: hidden;\n}\n\n.coupon-card-btn > div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem;\n  width: 100%;\n}\n\n.apply-btn {\n  background-color: #6da0ff0d;\n  color: var(--blue);\n}\n\n.dark .apply-btn {\n  background-color: #00123552;\n  color: var(--light-blue);\n}\n\n.applied-btn {\n  background-color: #eaffe9;\n  color: #00c400;\n}\n\n.dark .applied-btn {\n  background-color: #033f0087;\n  color: #00c400;\n}\n\n.coupon-btn-text {\n  letter-spacing: 3px !important;\n  overflow: hidden;\n  font-size: 14px !important;\n  font-weight: bold !important;\n}\n\n.coupon-card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding-top: 0.7rem;\n  border-top: 1px dashed #999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
